<template>
    <div class="row">
        <div class="col-12">
            <div class="card-group">
                <div :class="{'bg-light':activePlanId === plan.id}" class="card m-30 border-top border" v-bind:key="index" v-for="(plan, index) in planList">
                    <h5 class="price-label text-white text-center bg-success" v-if="activePlanId === plan.id">Active</h5>
                    <div class="p-15 text-center">
                        <h4 class="display-7 position-relative m-t-20 m-b-10">
                            {{plan.nickname}}
                        </h4>
                        <h5>
                            Billing Scheme - <span class="text-uppercase">{{plan.billing_scheme}}</span>
                        </h5>
                        <p v-if="plan.interval === 'month'">Per Month</p>
                        <p v-else-if="plan.interval === 'year'">Per Year</p>
                        <p v-else>Per Day</p>
                    </div>
                    <div class="border-top">
                        <ul class="list-style-none text-center">
                            <li class="border-bottom p-20">
                                <p><span class="font-bold">{{plan.amount/100}}</span><span class="text-uppercase"> {{plan.currency}}</span> per clusters.</p>
                            </li>
                            <li class="border-bottom p-20" v-if="activePlanId === plan.id">
                                <p><span class="font-bold">{{activeQuantity}}</span> Clusters are in current plan.</p>
                            </li>
                            <li class="border-bottom p-20" v-else>
                                <p>
                                    Count of Clusters :
                                    <vue-numeric-input :min="1" :value="1" @change="setQuantity($event)" controls-type="updown"></vue-numeric-input>
                                </p>
                            </li>

                            <li class="p-20">
                                <button @click="cancel()" class="btn btn-danger waves-effect waves-red" v-if="activePlanId === plan.id">Cancel</button>
                                <button @click="subscribe(plan.id)" class="btn btn-success waves-effect waves-light" v-else>Subscribe</button>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import VueNumericInput from 'vue-numeric-input'

    export default {
        name: "Plans",
        components: {
            VueNumericInput
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        props: {
            activePlanId: String,
            activeQuantity: String,
            activeSubscriptionId: String
        },
        data() {
            return {
                planList: [],
                quantity: 1,
                subscribeObj: {
                    planId: '',
                    quantity: 1,
                    currentPlanId: '',
                    activeSubscriptionId: ''
                }
            };
        },
        mounted() {
            this.getPlans();
        },
        methods: {
            async getPlans() {
                $(".preloader").fadeIn();
                let reply        = await this.$http.get(`/org/${this.currentOrg.id}/plans`);
                $(".preloader").fadeOut();
                this.planList    = reply.data;
            },
            setQuantity(e) {
                this.subscribeObj.quantity = e;
            },
            async subscribe(_planId) {
                this.subscribeObj.planId               = _planId;
                this.subscribeObj.activeSubscriptionId = this.activeSubscriptionId;
                this.subscribeObj.currentPlanId        = this.activePlanId;
                $(".preloader").fadeIn();
                await this.$http.post(`/org/${this.currentOrg.id}/subscriptions`, this.subscribeObj);
                $(".preloader").fadeOut();
                this.$toastr('success', 'New plan is successfully subscribed.', 'Subscribed!');
                this.$parent.getSubscriptions();
            },
            async cancel() {
                this.subscribeObj.currentPlanId        = this.activePlanId;
                this.subscribeObj.activeSubscriptionId = this.activeSubscriptionId;
                $(".preloader").fadeIn();
                await this.$http.post(`/org/${this.currentOrg.org_id}/subscriptions/cancel`, this.subscribeObj);
                $(".preloader").fadeOut();
                this.$toastr('success', 'Current plan is unsubscribed successfully.', 'Unsubscribed!');
                this.$parent.getSubscriptions();
            }
        }
    }
</script>

<style scoped>
    .preloader {
        width: 100%;
        height: 100%;
        top: 0;
        left: 262px;
        position: fixed;
        z-index: 99999;
        background: #ffffff69;
    }
</style>
